<template #time>
  <div class="form-time">
    <a-form-item>
      <a-date-picker
        :initialValue="moment(new Date())"
        :format="dateFormat"
        :disabled-date="startDateDisabledDate"
        @change="startDateChange"
        v-decorator="['startDate']" style="vertical-align: middle;width:150px;margin-right:10px" />
    </a-form-item>
    <a-form-item>
      <a-date-picker
        v-decorator="['endDate']"
        :disabled-date="disabledDate"
        :initialValue="moment(new Date())" :format="dateFormat"
        style="vertical-align: middle;width:150px;margin-right:10px" />
    </a-form-item>
  </div>
</template>

<script>
import moment from "moment";


export default {
  components: {},

  data() {
    return {
      dateFormat: this.$root.$data.dateFormat,
      startDate: undefined // 关联 disabledDate
    };
  },
  methods: {
    moment,

    disabledDate(endValue) {
      const startValue = this.startDate;
      if (!startValue) {
        return endValue.valueOf() > moment();
      }
      // 如果有开始时间  结束时间不能大于开始时间和当天
      return endValue.valueOf() < moment(this.startDate).valueOf() || endValue.valueOf() > moment();
    },
    startDateDisabledDate(current) {
      // Can not select days before today and today
      return current && current > moment();
    },
    startDateChange(val) {
      this.startDate = moment(val).format(this.dateFormat);
      this.$refs.formParent.form.setFieldsValue({
        endDate: undefined
      });
    }

  }
};
</script>

<style scoped>

</style>
